import freeBadgeImage from "@/assets/skool-free-badge.png";

export function SkoolPromoBanner() {
  return (
    <a
      href="https://www.skool.com/aiautomation-by-adam-8725/about"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Join AI Automation skool on Skool"
      className="group block h-[40px] w-full overflow-hidden bg-promo text-promo-foreground shadow-[0_1px_0_hsl(var(--promo-border))]"
    >
      <div className="mx-auto flex h-full max-w-[1120px] items-center justify-center gap-2 px-2 py-1 sm:gap-6 md:gap-12 lg:gap-16">
        <img
          src={freeBadgeImage}
          alt="Free"
          width="190"
          height="125"
          loading="eager"
          decoding="async"
          className="h-[25px] w-auto shrink-0 object-contain sm:h-[30px] md:h-[34px]"
        />

        <div className="flex min-w-0 items-center justify-center whitespace-nowrap text-center text-[clamp(0.9rem,3vw,2.15rem)] font-black leading-none tracking-normal">
          <span className="text-promo-blue px-0">AI</span>
          <span className="text-promo-orange">Auto</span>
          <span className="text-promo-yellow">mat</span>
          <span className="text-promo-blue-light">io</span>
          <span className="text-promo-orange">n</span>
          <span className="text-promo-blue px-0">s</span>
          <span className="text-promo-red">k</span>
          <span className="text-promo-yellow">o</span>
          <span className="text-promo-blue-light">o</span>
          <span className="text-promo-red">l</span>
        </div>

        <span className="shrink-0 rounded-xl border-promo-button-border bg-promo-join px-3 py-2 text-[11px] font-extrabold uppercase leading-none text-promo-join-foreground shadow-[0_0_0_2px_hsl(var(--promo-button-ring)),0_2px_5px_hsl(var(--promo-shadow))] transition-transform group-hover:scale-105 sm:px-5 sm:text-sm md:text-base border-0">
          Join Now
        </span>
      </div>
    </a>
  );
}